import React, { useState } from "react";
import Slider from "rc-slider";
import "./styles.css";
import logo from "./assets/logo.jpg";
import roadIcon from "./assets/road.png";
import houseIcon from "./assets/home.png";
import parkIcon from "./assets/park.png";
import foodIcon from "./assets/food.png";
import digitalDivideIcon from "./assets/digital_divide.png";
import homelessIcon from "./assets/homeless.png";
import useWindowDimensions from "./useWindowDimensions";
import { FacebookShareButton, FacebookIcon, LinkedinShareButton, LinkedinIcon, TwitterShareButton, TwitterIcon } from "react-share";

function SliderSection(props) {
  const { width } = useWindowDimensions();

  return (
    <>
      <tr>
        <td style={{ width: 10, display: "table-cell", verticalAlign: "bottom" }}>
          <img
            src={props.icon}
            height="50"
            style={{ display: "inline-block" }}
            alt={props.name}
          />
        </td>
        <td style={{ paddingLeft: 20, paddingRight: 20, width: (width <= 750 ? "90%" : "67%") }}>
          <p>
            {props.name}:{" "}
            <span style={{ fontWeight: "bold" }}>
              $
              {props.value.toLocaleString(undefined, {
                maximumFractionDigits: 2
              })}{" "}
              million{" "}
            </span>
          </p>
          <Slider
            tipProps={{ overlayClassName: "foo" }}
            step={props.step}
            max={props.max}
            onChange={props.onChange}
            value={props.value}
            railStyle={{ backgroundColor: "#007cbb" }}
            trackStyle={{ backgroundColor: "#007cbb" }}
            handleStyle={{
              borderColor: "#1c2f69",
              backgroundColor: "#1c2f69"
            }}
          />
          { width <= 750 && <div style={{ marginTop: 5 }}>{props.impact}</div>}
        </td>
        { width > 750 && 
          <td style={{ width: 330, position: "relative" }}>
            <span style={{ position: "absolute", bottom: 0 }}>{props.impact}</span>
          </td>
        }
      </tr>
    </>
  );
}

export default function App() {
  const [food, setFood] = useState(0);
  const [road, setRoad] = useState(0);
  const [homelessHousing, setHomelessHousing] = useState(0);
  const [parkFees, setParkFees] = useState(0);
  const [digitalDivide, setDigitalDivide] = useState(0);
  const [rentDebt, setRentDebt] = useState(0);
  const { width } = useWindowDimensions();

  function getQuote() {
    if (food === 0 && road === 0 && homelessHousing === 0 && parkFees === 0 && digitalDivide === 0 && rentDebt === 0) {
      return "The County just spent $76 million in federal relief funds on bonuses for their own employees, including top bureaucrats and senior management. How would you have spent the money differently?"
    }
    return "The County just spent $76 million in federal relief funds on bonuses for their own employees, including top bureaucrats and senior management.\n\nUsing Matt Mahan’s interactive tool, I re-allocated this $76 million to:\n"
    + (food !== 0 ? ("- Provide " + (0.26 * food).toLocaleString(undefined, {
      maximumFractionDigits: 1
    }) + (food === 0 ? "" : " million") + " meals\n") : "")

    + (road !== 0 ? ("- Pave " + road.toLocaleString(undefined, { maximumFractionDigits: 1 }) + 
    " mile" + (road !== 1 ? "s" : "") + " of road\n") : "")

    + (homelessHousing != 0 ? ("- House " +
    ((homelessHousing / 0.3) * 2).toLocaleString(undefined) + 
    " homeless people\n") : "") + 

    (parkFees !== 0 ? ("- Make county parks free for " + 
    (parkFees / 3.5).toLocaleString(undefined, {
      maximumFractionDigits: 1
    }) + " year" + (parkFees / 3.5 !== 1 ? "s" : "") + '\n') : "") + 
    (digitalDivide !== 0 ? ("- End the digital divide for " + 
    ((digitalDivide / 0.33) * 1000).toLocaleString(undefined, {
      maximumFractionDigits: 1
    }) + " students\n") : "") + 
    (rentDebt !== 0 ? ("- Forgive rent debt for " + 
    ((rentDebt / 0.46) * 100).toLocaleString(undefined) + " households") + '\n' : "")
  + "\nHow would you spend $76 million? Use this link to craft your own plan: https://holdsccaccountable.com";
  }

  function getShortQuote() {
    if (food === 0 && road === 0 && homelessHousing === 0 && parkFees === 0 && digitalDivide === 0 && rentDebt === 0) {
      return "Check out @mattmahansj’s interactive tool to hold the county accountable for spending. They recently spent $76 million on one time bonuses for all county employees. How would you have spent the money differently?";
    }
    return "Using @MattMahanSJ’s interactive tool, I spent $76 million to: \n"
    + (food !== 0 ? ("- Provide " + (0.26 * food).toLocaleString(undefined, {
      maximumFractionDigits: 1
    }) + (food === 0 ? "" : " million") + " meals\n") : "")

    + (road !== 0 ? ("- Pave " + road.toLocaleString(undefined, { maximumFractionDigits: 1 }) + 
    " mile" + (road !== 1 ? "s" : "") + " of road\n") : "")

    + (homelessHousing != 0 ? ("- House " +
    ((homelessHousing / 0.3) * 2).toLocaleString(undefined) + 
    " homeless people\n") : "") + 

    (parkFees !== 0 ? ("- Make county parks free for " + 
    (parkFees / 3.5).toLocaleString(undefined, {
      maximumFractionDigits: 1
    }) + " year" + (parkFees / 3.5 !== 1 ? "s" : "") + '\n') : "") + 
    (digitalDivide !== 0 ? ("- End the digital divide for " + 
    ((digitalDivide / 0.33) * 1000).toLocaleString(undefined, {
      maximumFractionDigits: 1
    }) + " students\n") : "") + 
    (rentDebt !== 0 ? ("- Forgive rent debt for " + 
    ((rentDebt / 0.46) * 100).toLocaleString(undefined) + " households") + '\n' : "")
  + "Create your own plan:";
}

  return (
    <div style={{ paddingLeft: (width <= 750) ? 8 : 12, paddingRight: (width <= 750) ? 8 : 12, paddingBottom: 10, boxSizing: "border-box" }}>
      {width < 1000 && <img
        src={logo}
        alt="Campaign Logo"
        style={{ display: "block", marginTop: 12, height: 75 }}
        className="center"
      />}
      <table style={{ display: "block", width: "100%" }}>
        <tbody>
          <tr>
            <td style={{ display: "table-cell", verticalAlign: "middle", whiteSpace: (width <= 750 ? "wrap" : "nowrap")}}>
              <h1>How would you spend $76 million?</h1>
            </td>
            {width > 1000 && <td style={{ width: "99%" }}>
              <img
                src={logo}
                alt="Campaign Logo"
                width="75%"
                style={{ display: "block", marginTop: 12, float: "right", maxWidth: 350 }}
              />
            </td>}
          </tr>
        </tbody>
      </table>
      <div style={{ marginTop: 20 }}>
        The Santa Clara County Board of Supervisors recently voted to spend $76 million 
        on bonuses for County employees, including management and top bureaucrats. With 
        families living on the streets, children going to bed hungry, and thousands still 
        unemployed due to the pandemic, this is clearly a <a target="_blank" href="https://www.mercurynews.com/2021/10/13/opinion-why-county-employee-bonuses-are-a-misuse-of-public-funds/">misuse of public funds</a>. What would 
        you have done differently?
        <div style={{ paddingTop: 10 }}/>

        <h2>Step 1: Craft Your Plan</h2>
        <span style={{ fontWeight: "bold", fontSize: 18, display: "block" }}>
          Money Spent: $
          {(
            food +
            road +
            parkFees +
            digitalDivide +
            rentDebt +
            homelessHousing
          ).toLocaleString(undefined, { maximumFractionDigits: 2 })}{" "}
          million{" "}
        </span>
      </div>
      <table style={{ marginBottom: 20, borderSpacing: "0px 15px"}}>
        <tbody>
          <SliderSection
            name={"Hunger"}
            step={0.1}
            max={76}
            value={food}
            onChange={(val) => {
              if (val + road + parkFees + digitalDivide + rentDebt + homelessHousing <= 76)
                setFood(val);
              else
                setFood(
                  Math.floor(
                    (76 - road - parkFees - digitalDivide - rentDebt - homelessHousing) / 0.1
                  ) * 0.1
                );
            }}
            impact={
              <>
                Provide{" "}
                <span style={{ fontWeight: "bold", fontSize: 17 }}>
                  {(0.26 * food).toLocaleString(undefined, {
                    maximumFractionDigits: 2, minimumFractionDigits: food != 0 ? 2 : 0
                  })}{" "}
                  {food === 0 ? "" : "million"} meals
                </span>{" "}
                to the hungry
              </>
            }
            icon={foodIcon}
          />
          <SliderSection
            name={"Roads"}
            step={1}
            max={62}
            value={road}
            onChange={(val) => {
              if (val + food + parkFees + digitalDivide + rentDebt + homelessHousing <= 76)
                setRoad(val);
              else
                setRoad(
                  Math.floor(76 - food - parkFees - digitalDivide - rentDebt - homelessHousing)
                );
            }}
            impact={
              <>
                Pave{" "}
                <span style={{ fontWeight: "bold", fontSize: 18 }}>
                  {road.toLocaleString(undefined, { maximumFractionDigits: 1 })}{" "}
                  mile{road !== 1 ? "s" : ""}
                </span>{" "}
                of county roads
              </>
            }
            icon={roadIcon}
          />
          <SliderSection
            name={"Homelessness"}
            step={0.3}
            max={76}
            value={homelessHousing}
            onChange={(val) => {
              if (val + road + parkFees + digitalDivide + food + rentDebt <= 76)
                setHomelessHousing(val);
              else
                setHomelessHousing(
                  Math.floor(
                    (76 - food - road - digitalDivide - parkFees - rentDebt) / 0.3
                  ) * 0.3
                );
            }}
            impact={
              <>
                House{" "}
                <span style={{ fontWeight: "bold", fontSize: 18 }}>
                  {((homelessHousing / 0.3) * 2).toLocaleString(undefined)}{" "}
                  homeless people
                </span>{" "}
                in low-cost, modular apartments
              </>
            }
            icon={homelessIcon}
          />
          <SliderSection
            name={"Park Fees"}
            step={3.5}
            max={76}
            value={parkFees}
            onChange={(val) => {
              if (val + food + road + digitalDivide + rentDebt + homelessHousing<= 76)
                setParkFees(val);
              else
                setParkFees(
                  Math.floor(
                    (76 - food - road - digitalDivide - rentDebt - homelessHousing) / 3.5
                  ) * 3.5
                );
            }}
            impact={
              <>
                Make county parks free for{" "}
                <span style={{ fontWeight: "bold", fontSize: 18 }}>
                  {(parkFees / 3.5).toLocaleString(undefined, {
                    maximumFractionDigits: 1
                  })}{" "}
                  year{parkFees / 3.5 !== 1 ? "s" : ""}
                </span>
              </>
            }
            icon={parkIcon}
          />
          <SliderSection
            name={"Digital Divide"}
            step={0.33}
            max={13.2}
            value={digitalDivide}
            onChange={(val) => {
              if (val + road + parkFees + food + rentDebt + homelessHousing <= 76)
                setDigitalDivide(val);
              else
                setDigitalDivide(
                  Math.floor((76 - food - road - parkFees - rentDebt - homelessHousing) / 0.33) *
                    0.33
                );
            }}
            impact={
              <>
                End the digital divide for{" "}
                <span style={{ fontWeight: "bold", fontSize: 18 }}>
                  {((digitalDivide / 0.33) * 1000).toLocaleString(undefined, {
                    maximumFractionDigits: 1
                  })}{" "}
                  students
                </span>{" "}
                in the county
              </>
            }
            icon={digitalDivideIcon}
          />
          <SliderSection
            name={"Rent Debt"}
            step={0.46}
            max={59}
            value={rentDebt}
            onChange={(val) => {
              if (val + road + parkFees + digitalDivide + food + homelessHousing <= 76)
                setRentDebt(val);
              else
                setRentDebt(
                  Math.floor(
                    (76 - food - road - digitalDivide - parkFees - homelessHousing) / 0.46
                  ) * 0.46
                );
            }}
            impact={
              <>
                Forgive rent debt for{" "}
                <span style={{ fontWeight: "bold", fontSize: 18 }}>
                  {((rentDebt / 0.46) * 100).toLocaleString(undefined)} households
                </span>{" "}
              </>
            }
            icon={houseIcon}
          />
        </tbody>
      </table>
      <div style={{ fontWeight: "bold", marginBottom: 12, display: "block"}}>
        <h2 style={{ marginBottom: 10 }}>Step 2: Share Your Plan:</h2>
        <div style={{ display: "block" }}>
          <FacebookShareButton 
            quote={getQuote()}
            url="https://holdsccaccountable.com"
            style={{ marginRight: 10 }}
          >
            <FacebookIcon size={42} round={true}></FacebookIcon>
          </FacebookShareButton>
          <TwitterShareButton
            title={getShortQuote()}
            url="https://holdsccaccountable.com"
            style={{ marginRight: 10 }}
          >
            <TwitterIcon size={42} round={true}></TwitterIcon>
          </TwitterShareButton>
          <LinkedinShareButton 
            title="Hold the County Accountable"
            summary={getQuote()}
            source="https://holdsccaccountable.com"
            url="https://holdsccaccountable.com"
            style={{ marginRight: 10 }}
          >
            <LinkedinIcon size={42} round={true}></LinkedinIcon>
          </LinkedinShareButton>
        </div>
      </div>
      <div style={{ marginBottom: 10, display: "block", clear: "left" }}>
        Matt Mahan is running for Mayor of San Jose to lead a Revolution of Common Sense. Learn more{" "}
        <a
          href="https://mahanforsanjose.com"
          target="_blank"
        >
          here
        </a>
        .
        <br/>
        <div style={{ marginTop: 10 }}>Paid for by Neighbors for Matt Mahan for Mayor 2022, FPPC #1441269.</div>
      </div>
      <div style={{ fontSize: 12, display: "block" }}>Made by <a href="https://www.linkedin.com/in/nathan-gong-2103a2198" target="_blank">Nathan</a> and <a href="https://www.linkedin.com/in/veer-juneja-67255417a/" target="_blank">Veer</a>.</div>
    </div>
  );
}
